module.exports = __webpack_public_path__ + "static/media/add.88007798.svg";